// Shared date/time formatting helpers.

// Format an ISO timestamp as a locale date+time string. Returns "—" for null/invalid input.
export const formatDateTime = (value?: string | null): string => {
  if (!value) return "—";
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleString();
};

// Time-of-day greeting for the Home header. Local clock, matching the admin app's cutoffs.
export const greetingForNow = (now: Date = new Date()): string => {
  const h = now.getHours();
  if (h < 12) return "morning";
  if (h < 17) return "afternoon";
  return "evening";
};

// First name only — a greeting reads wrong with a full legal name in it.
export const firstNameOf = (name?: string | null): string =>
  (name ?? "").trim().split(/\s+/)[0] || "";

// Compact span for narrow rows — "4m", "4h", "2d" — on formatTimeAgo's cutoffs so the two never drift
export const formatSpanShort = (minutes: number): string => {
  const mins = Math.max(0, Math.round(minutes));
  if (mins < 60) return `${mins}m`;
  const hours = Math.round(mins / 60);
  if (hours < 48) return `${hours}h`;
  return `${Math.round(hours / 24)}d`;
};

// Relative age of a timestamp — "just now", "4h ago", "2d ago". Returns null for missing/invalid input so callers can pick their own fallback wording rather than being handed a placeholder.
export const formatTimeAgo = (value?: string | Date | null): string | null => {
  if (!value) return null;
  const then = value instanceof Date ? value.getTime() : new Date(value).getTime();
  if (Number.isNaN(then)) return null;
  const minutes = Math.max(0, Math.round((Date.now() - then) / 60000));
  if (minutes < 1) return "just now";
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 48) return `${hours}h ago`;
  const days = Math.round(hours / 24);
  if (days < 60) return `${days}d ago`;
  return `${Math.round(days / 30)}mo ago`;
};
